<mat-checkbox
    #inputElement
    color="primary"
    [formControl]="formControl"
    [ngClass]="{
        'error-border': !visuallyDisabled && formControl.invalid,
        'visually-disabled': visuallyDisabled,
    }"
></mat-checkbox>
